import { JSX } from 'react';

import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { Command, OptionIcon } from 'lucide-react';

import { KeyFace } from '@/components/hotKeyLineWithButtonAndDescription/shortCut.styles.ts';
import { getDisplayModifier, isMac } from '@/hooks/shortcutHooks/hotkeyLabels.ts';
import { HotkeyModifier, ModifierType } from '@/hooks/shortcutHooks/hotkeys';
import { iconStyle } from '@/pages/layouts/getStartedModal/gettingStarted_KeyboardShortcuts/types.ts';
import { Icon, responsive } from '@/utils';

const getModifierIcon = (modifierType?: ModifierType) => {
  if (modifierType === 'Alt' && isMac) {
    return <OptionIcon size={14} />;
  }
  if (modifierType === 'Meta' && isMac) {
    return <Command size={14} />;
  }
  if (modifierType === 'Shift') {
    return <Icon.ArrowUp size='large' style={{ ...iconStyle, width: '1rem' }} />;
  }
  return undefined;
};

type KeyboardModifierWithOptionalIconProps = {
  hotkeyModifier?: HotkeyModifier;
};

type KeyboardModifierWithOptionalIconType = ({
  hotkeyModifier,
}: KeyboardModifierWithOptionalIconProps) => JSX.Element | undefined;

export const KeyboardModifierWithOptionalIcon: KeyboardModifierWithOptionalIconType = ({
  hotkeyModifier,
}) => {
  const modifier = getDisplayModifier(hotkeyModifier?.modifier);
  if (modifier === undefined) {
    return undefined;
  }

  const modifierIcon = getModifierIcon(hotkeyModifier?.modifier);

  return (
    <FlexAligner gap={responsive.spacing['large']} spaceBetween alignment={'center'}>
      <KeyFace
        style={{
          flexDirection: hotkeyModifier?.isModifierIconLast ? 'row-reverse' : 'row',
        }}
      >
        {modifierIcon && <span style={{ width: '1rem' }}>{modifierIcon}</span>}
        <Typography>{modifier}</Typography>
      </KeyFace>
      <Typography>{'+'}</Typography>
    </FlexAligner>
  );
};
